import { RootAppState } from 'store/configureStore'

export const projectCreatedInPortalSelector = (state: RootAppState) =>
  state.project.activeProject?.createdInPortal
